import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import AppBar from "./Common/AppBar";
import Drawer from "./Common/Drawer";
import Copyright from "./Common/Copyright";
import Chart from "./Dashboard/Chart";
import SessionList from "./Sessions/SessionList";
import ValueBox from "./Dashboard/ValueBox";

// TODO remove, this demo shouldn"t need to reset the theme.
const defaultTheme = createTheme();

export const Dashboard = ({ token }) => {
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const [CountSessionsActive, setCountSessionsActive] = React.useState();
  const [CountSessionsTotal, setCountSessionsTotal] = React.useState();

  const [CountIssues, setCountIssues] = React.useState();

  const updateCountSessions = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/stats/sessions/active`, 
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Token": token
            }
        }
    )
    .then((response) => response.json())
    .then((data) => {
        setCountSessionsActive(data.count)
    }).catch((error) => console.error("Error fetching active sessions count:", error));
  
    fetch(`${process.env.REACT_APP_API_URL}/stats/sessions/total`, 
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Token": token
            }
        }
    )
    .then((response) => response.json())
    .then((data) => {
        setCountSessionsTotal(data.count)
    }).catch((error) => console.error("Error fetching total sessions count:", error));
  }

  const updateCountIssues = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/stats/issues/total`, 
    {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Token": token
        }
    }
    )
    .then((response) => response.json())
    .then((data) => setCountIssues(data.count))
    .catch((error) => console.error("Error fetching total issues count:", error));
  }
  
  React.useEffect(() => {
      updateCountSessions();
      updateCountIssues();
  });

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar open={open} toggleDrawer={toggleDrawer} />
        <Drawer open={open} toggleDrawer={toggleDrawer} />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
              {/* Chart */}
              <Grid item xs={12} md={8} lg={6}>
                <Paper
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: 240,
                  }}
                >
                  <Chart />
                </Paper>
              </Grid>
              {/* Active Sessions */}
              <Grid item xs={12} md={4} lg={3}>
                <Paper
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: 240,
                  }}
                >
                  <ValueBox title="Active Sessions" value={CountSessionsActive} />
                </Paper>
              </Grid>
              {/* Total Sessions */}
              <Grid item xs={12} md={4} lg={3}>
                <Paper
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: 240,
                  }}
                >
                  <ValueBox title="Total Sessions" value={CountSessionsTotal} />
                </Paper>
              </Grid>
              <Grid item xs={12} md={4} lg={3}>
                <Paper
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: 240,
                  }}
                >
                  <ValueBox title="Total Issues" value={CountIssues} />
                </Paper>
              </Grid>
            </Grid>
            <Copyright sx={{ pt: 4 }} />
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default Dashboard;